export const ASSET_BASE =
  'https://drwzpk38qkpfb.cloudfront.net/site8970-1.websiteforge.com/'

export const asset = (path: string): string => `${ASSET_BASE}${path}`

export const PHONE_DISPLAY = '517-545-7772'
export const PHONE_HREF = 'tel:+15175457772'

/* Company-wide toll-free line shown in the header only. Office-specific
   numbers stay on their own locations. */
export const TOLL_FREE_DISPLAY = '888-2-KOSINS'
export const TOLL_FREE_NUMERIC = '888-256-7467'
export const TOLL_FREE_HREF = 'tel:+18882567467'

export const PRIVACY_URL = '/privacy-policy.html'

export const LINKS = {
  auto: '/autoglass.html',
  windshield: '/windshieldreplacement.html',
  chip: '/Windshield-Chip-Repair',
  residential: '/residentialglass.html',
  shower: '/euroglasshowerdoors.html',
  commercial: '/commercialglass.html',
  emergencyAuto:
    '/emergency-auto-glass-repair.html',
  adas: '/ADAS-Calibration-On-Site',
  contact: '/contact-kosins-glass.html',
  resources: '/glass-resources-expert-guides',
}

export const IMAGES = {
  logo: asset('uploaded/images/logo.png'),
  heroWide:
    'https://cdn.magicpatterns.com/uploads/iSZa5SWDZYDMY442Yv8mFV/kosins-scale-corrected-panorama.png',
  heroMobile:
    'https://cdn.magicpatterns.com/uploads/oAFbjZ3ABLi6ZyTwKLVwmk/kosins-scale-corrected-mobile-v2.png',
  heroStorefront:
    'https://cdn.magicpatterns.com/uploads/bd8LBYc1ZaeG7Wx8Qoz2QR/kosins-storefront-restored-v2.png',
  auto: asset('uploaded/images/NewDesign/Emergency_Auto.png'),
  residential: asset('uploaded/images/New%20Design/residential.jpg'),
  shower: asset('uploaded/images/NewDesign/GSDpic5.webp'),
  showerAlt: asset('uploaded/images/NewDesign/GSDpic1.webp'),
  commercial:
    'https://cdn.magicpatterns.com/uploads/oNSmH2ytcACWppTvokkR1X/kosins-modern-old-navy-storefront.png',
  commercialAlt: asset('uploaded/images/NewDesign/commercialpic9.webp'),
  autoDetail:
    'https://cdn.magicpatterns.com/uploads/cR9EwKCiKWiR7n7QBiAUWj/kosins-auto-windshield-detail.png',
  commercialDetail:
    'https://cdn.magicpatterns.com/uploads/3xsSuhKf8TG7fGc6x4fbvA/kosins-commercial-glass-detail.png',
  residentialDetail:
    'https://cdn.magicpatterns.com/uploads/isV67m5yUetKZqnonuMS3H/kosins-residential-picture-window.png',
  showerThumbnail:
    'https://cdn.magicpatterns.com/uploads/i3WEmiVJWxx6nnDfSH1yXd/kosins-shower-door-thumbnail.png',
}
